/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import { useDispatch } from "react-redux";
import { persistReducer, persistStore } from "redux-persist";

import { persistConfig } from "./persistConfig";
import rootReducer from "./rootReducer";

enableMapSet();
const persistedReducer = persistReducer(persistConfig, rootReducer);

enableMapSet();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _configureStore = (initialState?: any) => {
  return configureStore({
    preloadedState: initialState,
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: { warnAfter: 128 },
      }),
  });
};

const store = _configureStore();

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types

export const initialGlobalState = store.getState();

export default store;
